export default __webpack_public_path__ + "static/media/partnerCross.6d57fb36.webp";